import { render, staticRenderFns } from "./EmailCustom.vue?vue&type=template&id=2c34380f&scoped=true&"
import script from "./EmailCustom.vue?vue&type=script&lang=js&"
export * from "./EmailCustom.vue?vue&type=script&lang=js&"
import style0 from "./EmailCustom.vue?vue&type=style&index=0&id=2c34380f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c34380f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c34380f')) {
      api.createRecord('2c34380f', component.options)
    } else {
      api.reload('2c34380f', component.options)
    }
    module.hot.accept("./EmailCustom.vue?vue&type=template&id=2c34380f&scoped=true&", function () {
      api.rerender('2c34380f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/EmailCustom.vue"
export default component.exports